import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../services/language.service';

@Component({
    selector: 'app-competence',
    templateUrl: 'competence.component.html',
    styleUrls: ['../pages.scss', 'competence.component.scss']
})

export class CompetenceComponent {
    activeLanguage = 'german';
    constructor(private ls: LanguageService) {
        ls.getLanguage().subscribe(val => {
            this.activeLanguage = val;
        });
    }
    content = {
        german: `
<div class="row margin-below">
    <div class="col">
      <h1 class="header">Kompetenz</h1>
    </div>
</div>
<div class="row">
    <div class="text-content col-12 col-sm-9">
        <h5>
            <span class="highlight">Dr. rer. nat. Klaus Wolke</span>
        </h5>
        <p>
            Geschäftsführer / Managing Director
        </p>
        <p>Studium der Physik und Promotion in Münster</p>
        <p>15 Jahre Erfahrung in Prozesstechnik und Produktion bei internationaler HL Fertigung (IBM) und im Anlagenbau (STEAG, Mattson, SCP)</p>
        <p>Bereichsleiter Technologie und Produktentwicklung für Reinigungstechnologie</p>
        <p>Betriebliche Verantwortung in der Geschäftsleitung für Marketing, Entwicklung und Produktion</p>
        <p>Seit 2005 selbständige Unternehmensberatung in typischen Technologiebranchen (Automotive, Semiconductor, PV, Anlagenbau, Medizintechnik)</p>
        <p>
            Beratungsschwerpunkte:
            <ul>
                <li>Clean Technology</li>
                <li>Entwicklungsprozesse</li>
                <li>Portfoliomanagement</li>
                <li>Produktzuverlässigkeit</li>
                <li>Effiziente Produktion</li>
            </ul>
        </p>
    </div>
    <div class="image-content col-8 col-sm-3" style="margin: auto">
      <img class="img-responsive" src="/assets/profile.jpg">
    </div>
</div>
<div class="row">
    <div class="text-content col-12 col-sm-9">
            <h5 style="margin-top: 20px;">
                <span class="highlight">Netzwerkpartner</span>
            </h5>
        <p>
            <a class="bold" href="https://tc-koch.de/" data-target="_blank">Dipl. Phys. Jochen Koch</a>: Über 20 Jahre Berufserfahrung im Bereich
            Technologie und Qualität Halbleiterproduktion (IBM, NXP), seit 2008 Unternehmensberater für Produktqualifikationen und Statistik<br>
            Fachgebiete:
            <ul>
                <li>Produktentwicklung nach TS16949</li>
                <li>Statistische Datenanalyse</li>
                <li>Projektmanagement</li>
                <li>Coaching</li>
            </ul>
        </p>
        <p>
            <a class="bold"  href="http://www.fmea-compact.de/" data-target="_blank">Dr. Britta Maid</a>: Über 20 Jahre Berufserfahrung in Product Assurance und Zuverlässigkeit<br>
            Fachgebiete:
            <ul>
                <li>Produktzuverlässigkeit</li>
                <li>FMEA</li>
                <li>Funktionale Sicherheit</li>
                <li>Moderation</li>
            </ul>
        </p>
        <p>
            <span class="bold">Dipl. Ing. Rita Kagerer</span>: 20 Jahre Erfahrung in Product engineering Quality Management bei IBM,
            Philips, NXP; gepr. Auditor für QM<br>
            Fachgebiete:
            <ul>
                <li>Qualitätsmanagementsysteme</li>
                <li>Iso Zertifizierungen</li>
                <li>QM Auditierung</li>
            </ul>
        </p>
        <p>
            <a class="bold"  href="http://www.fmea-compact.de/" data-target="_blank">Dr. Wolfgang Rauscher</a>, Dipl. Chem.: 30 Jahre Berufserfahrung in
            Technologieentwicklung und -Produktion; Qualitätsmanagement, ISO 9001-2000
            <ul>
                <li>Produktentwicklung</li>
                <li>Validierung</li>
                <li>Regulatory Affairs</li>
                <li>Arbeitssicherheit</li>
            </ul>
        </p>
        <p>
            <span class="bold">Dipl. Ing. Ernst Epple</span>: Vorm. Entwicklungs- und Serviceleiter beim Anlagenbau für Reinraumprodukte<br>
            Fachgebiete:
            <ul>
                <li>Anlagenplanung</li>
                <li>Konstruktion</li>
                <li>Projektleiter</li>
                <li>Produktentwicklung</li>
            </ul>
        </p>
    </div>
</div>
`,
      english: `
      <div class="row margin-below">
      <div class="col">
        <h1 class="header">Competence</h1>
      </div>
  </div>
  <div class="row">
      <div class="text-content col-12 col-sm-9">
          <p>
              <span class="highlight">Dr. rer. nat. Klaus Wolke</span>
          </p>
          <p>
              CEO / Managing Director of TCW
          </p>
          <p>Master of  Physics und Doctorate from University of Münster, Germany</p>
          <p>More than 15 years experience in process technology and production of semiconductors  at IBM and capital equipment industry (STEAG, Mattson, SCP)</p>
          <p>Director of technology and product development division at STEAG and SCP with up to 40 team members</p>
          <p>Member of SCP Germany Management Team for Marketing, R&D and production</p>
          <p>Since 2005: Independent advisory for technology driven industries  (Semiconductor, PV, Capital equipment, Automotive, Medical)</p>
          <p>
               Consultancy expertise:
              <ul>
                  <li>Clean Technology and production in clean environments</li>
                  <li>Business process optimization in development and production</li>
                  <li>Operational excellence</li>
                  <li>Portfolio management</li>
                  <li>Product assurance and reliability</li>
                  <li>Project management</li>
              </ul>
          </p>
      </div>
      <div class="image-content col-8 col-sm-3" style="margin: auto">
        <img class="img-responsive" src="/assets/profile.jpg">
      </div>
  </div>
    `,
    };

}



// WEBPACK FOOTER //
// ./src/app/components/competence/competence.component.ts